/**
 * Labstep
 *
 * @module components/Folder/Action/Menu
 * @desc Action Menu for folder
 */

import { EntityUserActionManage } from 'labstep-web/components/EntityUser/Action/Manage';
import { FolderActionCreateSub } from 'labstep-web/components/Folder/Action/CreateSub';
import { FolderActionDelete } from 'labstep-web/components/Folder/Action/Delete';
import { FolderActionEdit } from 'labstep-web/components/Folder/Action/Edit';
import { FolderActionShare } from 'labstep-web/components/Folder/Action/Share';
import FolderActionUpdateOuter from 'labstep-web/components/Folder/Action/UpdateOuter';
import { ActionMenu } from 'labstep-web/core/Action/Menu';
import type React from 'react';
import type { FolderActionMenuProps } from './types';

export enum Action {
  edit = 'edit',
  delete = 'delete',
  add_subfolders = 'add_subfolders',
  update_outer = 'update_outer',
  assign = 'assign',
  share = 'share',
}

export const FolderActionMenu: React.FC<FolderActionMenuProps> = ({
  folder,
  folderType,
  type,
  actions = [],
  options,
}) => {
  return (
    <ActionMenu type={type}>
      {actions.includes(Action.edit) && (
        <FolderActionEdit
          actionComponentProps={{ type: 'option' }}
          folder={folder}
        />
      )}
      {actions.includes(Action.add_subfolders) && (
        <FolderActionCreateSub
          folder={folder}
          folderType={folderType}
        />
      )}
      {actions.includes(Action.update_outer) && (
        <FolderActionUpdateOuter
          folder={folder}
          folderType={folderType}
        />
      )}
      {!folder.outer_folder && actions.includes(Action.share) && (
        <FolderActionShare
          folder={folder}
          actionComponentProps={{ type: 'option' }}
        />
      )}
      {actions.includes(Action.assign) &&
        (folderType === 'experiment_workflow' ||
          folderType === 'protocol_collection') && (
          <EntityUserActionManage entity={folder} />
        )}
      {actions.includes(Action.delete) && (
        <FolderActionDelete folder={folder} options={options} />
      )}
    </ActionMenu>
  );
};

FolderActionMenu.defaultProps = {
  actions: [],
  type: 'icon',
};
